<script setup lang="ts">
  import { FormFieldContainer, InputField, UiButton } from '@logistiek-zonder-papier/lzp-library'

  const code = defineModel<string>()
  const emit = defineEmits(['submit'])
  const props = defineProps<{ isSubmitting: boolean; errorMessage: string | undefined }>()
</script>

<template>
  <FormFieldContainer label="E-mailcode" :error="props.errorMessage">
    <InputField
      v-model="code"
      :error="!!props.errorMessage"
      type="text"
      autofocus
      placeholder="Voer de code uit uw e-mail in"
      required
      @keyup.enter="emit('submit')"
    />
  </FormFieldContainer>

  <UiButton
    label="Verzenden"
    variant="prominent"
    :disabled="props.isSubmitting"
    type="submit"
    @click="emit('submit')"
  />
</template>

<style scoped>
  .error {
    color: var(--colours-support-negative);
  }
</style>
